




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionLinkStoreEdit from '@/store/modules/cvSectionLinkEdit';
import EditContainer from '@/containers/cv-section-link/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionLinkStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, id } = params;
  await store.dispatch(
    CvSectionLinkStoreEdit.GetCvSectionLink.namespaced({
      params: { cv_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionLinkStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionLink']),
  },
});
